
import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { CwUtils } from 'cw-utils';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiGateway } from '../../../api-gateway';
import { TableTypeVersion } from '../../../models/backend-definitions.module';
import { PageOptions } from '../../../util/backend-util-module';

@Injectable()
export class TableTypeVersionListProvider implements Resolve<any> {
    tableTypeVersion: TableTypeVersion[];
    tableTypeVersionEdit: TableTypeVersion;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(
        public gw: ApiGateway,
        private location: Location,
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        if (this.state?.currentPage && state.url.includes(this.state?.path)) {
            this.currentPage = this.state?.currentPage;
        }
        this.tableTypeVersionEdit = this.state?.currentTableTypeVersion;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
        }
        else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = 'name';
        }
        return new Promise<void>((resolve, reject) => {
            Promise.all([
                this.getPage(this.pageOptions)
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    get(id: number): Observable<TableTypeVersion> {
        if (!id) {
            return null;
        }
        return this.gw.get('tableTypeVersion/:id', { id: id });
    }

    get currentTableTypeVersion(): TableTypeVersion {
        return this.tableTypeVersionEdit;
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get('tableTypeVersion/').subscribe((res: HttpResponse<any>) => {
                this.tableTypeVersion = res.body;
                this.onDataChanged.next(this.tableTypeVersion);
                resolve(res);
            }, reject);
        });

    }

    getPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('tableTypeVersion/search', pageOptions).subscribe((res: HttpResponse<any>) => {
                if (!CwUtils.compare(this.tableTypeVersion, res.body.content) && res.body.content.length > 0) {
                    this.tableTypeVersion = res.body.content;
                    this.onDataChanged.next(this.tableTypeVersion);
                } else {
                    this.tableTypeVersion = res.body.content;
                }
                resolve(res);
            }, reject);
        });
    }

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }
}

